import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ArrayUtil from '../../utils/ArrayUtil';
import Box from './Box';
import BoxNoData from './BoxNoData';

class AssessmentsTimeline extends Component {
  render() {
    const {
      respondent,
      assessments,
      ownerUiPreferences,
      availableTranslations,
      surveyError,
      currentAccount,
    } = this.props;
    const assessmentsTimelineBox = (
      <div className="timeline">
        {assessments.map(asmt => (
          <Box
            currentAccount={currentAccount}
            surveyError={surveyError}
            respondent={respondent}
            assessment={asmt}
            key={asmt.id}
            availableTranslations={availableTranslations}
            ownerUiPreferences={ownerUiPreferences}
          />
        ))}
      </div>
    );

    return (
      <div className="panel-body panel-white">
        {ArrayUtil.isNotEmpty(assessments) ? assessmentsTimelineBox : <BoxNoData respondent={respondent} />}
      </div>
    );
  }
}

AssessmentsTimeline.propTypes = {
  respondent: PropTypes.objectOf(PropTypes.any).isRequired,
  assessments: PropTypes.arrayOf(PropTypes.any).isRequired,
  ownerUiPreferences: PropTypes.objectOf(PropTypes.any),
  availableTranslations: PropTypes.arrayOf(PropTypes.any).isRequired,
  surveyError: PropTypes.bool.isRequired,
  currentAccount: PropTypes.string.isRequired,
};

AssessmentsTimeline.defaultProps = {
  ownerUiPreferences: null,
};

export default AssessmentsTimeline;
